const variantWidget = document.querySelector("[js-variant-widget]");
if(variantWidget) {
    const variantFields = variantWidget.querySelectorAll("[js-variant-field]");
    const sellingPlanFields = variantWidget.querySelectorAll("[js-selling-plan-field]");
    const stickyVariantPriceEl = document.querySelector("[js-sticky-product-regular-price]");
    const variantPriceEl = document.querySelector("[js-product-regular-price]");
    const formId = variantWidget.getAttribute("data-form-id");

    variantFields?.forEach(el => {
        el.addEventListener("change", function() {
            sellingPlanFields.forEach(sellingPlanField => sellingPlanField.removeAttribute("form"));

            if(this.getAttribute("is") === "subscription") {
                const variantBox = this.closest("[js-variant-box]");
                const sellingPlanField = variantBox.querySelector("[js-selling-plan-field]");
                sellingPlanField.setAttribute("form", formId);
            };

            if(variantPriceEl) {
                variantPriceEl.textContent = this.getAttribute('data-price');
            }
            if(stickyVariantPriceEl) {
                stickyVariantPriceEl.textContent = this.getAttribute("data-price");
            }
        })
    })
}